export default "__VITE_ASSET__BVrAlz1E__"